<template>

	<el-container class="index-con">
		<el-aside :class="showclass">
			<leftnav></leftnav>
		</el-aside>
		<el-container class="main-con">
			<el-header class="index-header">
				<navcon></navcon>
			</el-header>
		
			<div style="margin-top: 10px;padding-left: 30px;">
				<common-tab></common-tab>
			</div>
			<el-main clss="index-main">
				<router-view></router-view>
			</el-main>
		</el-container>
	</el-container>
</template>
<script>
	// 导入组件
	import navcon from '../components/navcon.vue'
	import leftnav from '../components/leftnav.vue'
	import CommonTab from '../components/commonTab.vue'
	export default {
		name: 'index',
		data() {
			return {
				showclass: 'asideshow',
				showtype: false
			}
		},
		// 注册组件
		components: {
			navcon,
			leftnav,
			CommonTab
		},
		methods: {},
		created() {
			// console.log(this.$router.options.routes)

			if (window.location.href.indexOf('code') >= 0) {
				let code = window.location.href.split('?')[1];
				code = code.substring(5, code.indexOf('&'));
				this.wechatcode = code
				console.log('index', this.wechatcode)

			}
			// 监听
			this.$root.Bus.$on('toggle', value => {
				if (value) {
					this.showclass = 'asideshow'
				} else {
					setTimeout(() => {
						this.showclass = 'aside'
					}, 300)
				}
			})
		},
		beforeUpdate() {},
		// 挂载前状态(里面是操作)
		beforeMount() {
			// 弹出登录成功
			// this.$message({
			//   message: '登录成功',
			//   type: 'success'
			// })
		}
	}
</script>
<style>
	.index-con {
		height: 100%;
		width: 100%;
		box-sizing: border-box;
	}

	.aside {
		width: 64px !important;
		height: 100%;
		background-color: #334157;
		margin: 0px;
	}

	.asideshow {
		width: 240px !important;
		height: 100%;
		background-color: #334157;
		margin: 0px;
	}

	.index-header,
	.index-main {
		padding: 0px;
		border-left: 2px solid #333;
	}

	.el-header {
		padding: 0px !important;
	}
</style>
